import { RouterProvider, matchRoute, useRouter } from "./lib/router.js";
import { Home } from "./screens/Home.js";
import { Create } from "./screens/Create.js";
import { Lobby } from "./screens/Lobby.js";
import { Join } from "./screens/Join.js";
import { Game } from "./screens/Game.js";

function Routes() {
  const { path } = useRouter();

  const gameMatch = matchRoute("/g/:id", path);
  if (gameMatch) return <Game id={gameMatch.id!} />;

  const joinLink = matchRoute("/j/:code", path);
  if (joinLink) return <Join initialCode={joinLink.code} />;

  if (path === "/create") return <Create />;
  if (path === "/lobby") return <Lobby />;
  if (path === "/join") return <Join />;
  return <Home />;
}

export default function App() {
  return (
    <RouterProvider>
      <div className="min-h-full">
        <Routes />
      </div>
    </RouterProvider>
  );
}
